module.exports = __webpack_public_path__ + "media/images/img/tag_company/ntt_com_tag-13ed45420670461e9c3180e32f892a84.png";